import { render, staticRenderFns } from "./SettingsWarning.vue?vue&type=template&id=a7a3ab74&scoped=true&"
import script from "./SettingsWarning.vue?vue&type=script&lang=js&"
export * from "./SettingsWarning.vue?vue&type=script&lang=js&"
import style0 from "./SettingsWarning.vue?vue&type=style&index=0&id=a7a3ab74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a3ab74",
  null
  
)

export default component.exports